
<div class="page-top">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
</div>



